module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/43dYMO/tc-custom/9781613129340.jpg?1703878794028",
      "alt": "This image is the cover for the book Like My Teacher Always Said . . ."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Like My Teacher Always Said . . .\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Quotes from teachers that stayed with their students—from the life-changing to the head-scratching.")]), _c('br'), _c('br'), _c('i', [_vm._v("My high school chemistry teacher used to tell us, “Carol never wore her safety goggles. Now, she doesn’t need them.” It was a joke. I think. But it sure got the point across.")]), _vm._v("—Alicia on Mr. P."), _c('br'), _c('br'), _vm._v("The author of "), _c('i', [_vm._v("Like My Mother Always Said ")]), _vm._v("and "), _c('i', [_vm._v("Like My Father Always Said ")]), _vm._v("returns with a new crowdsourced collection of quips, quotes, and stories from people recalling childhood influences from grade school instructors to piano teachers, Catholic school sisters, guidance counselors, coaches, and mentors. In addition, teachers themselves have contributed some entertaining reminiscences and tales from the classroom."), _c('br'), _c('br'), _vm._v("With chapters such as “Scare Tactics,” “Advice That Stuck,” and “Crazy Town,” the entries range from the wise to the weird—provoking nostalgia, inspiration, and more than a few good laughs.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Erin McHugh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Based in New York, Erin McHugh is a former publishing executive and author of more than 25 books of trivia, history, children’s titles, and more.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0